new ScrollHint(".js-scrollable", {
  suggestiveShadow: true,
  // remainingTime: 5000,
  i18n: {
    scrollable: "スクロールできます",
  },
});

// mobile-nav__linkがクリックされたときの処理
document.addEventListener("click", function (event) {
  // クリックされた要素がmobile-nav__linkクラスを持っているかを確認
  if (event.target.classList.contains("mobile-nav__link")) {
    // mobile-menu-drawerというIDを持つ要素を取得
    var mobileMenuDrawer = document.getElementById("mobile-menu-drawer");

    // mobile-menu-drawerが存在し、open属性を持っている場合
    if (mobileMenuDrawer && mobileMenuDrawer.hasAttribute("open")) {
      // open属性を削除
      mobileMenuDrawer.removeAttribute("open");
    }
  }
});

// アカウントページのクーポンコード表示
const observer = new MutationObserver((mutations, obs) => {
  const span = document.querySelector(".socialplus-association-status");
  if (span && span.textContent.trim() === "連携済") {
    console.log("Element found, modifying DOM.");
    var htmlContent = `
      <div class="coupon-wrapper">
        <h2 class="title">300円オフクーポン</h2>
        <p class="text">お支払い画面でクーポンコード<br>【POMULU-R300】を入力してご使用ください。</p>
        <p class="comment">※クーポンは一度のみご使用いただけます。</p>
        <div class="coupon-banner">
          <img src="https://cdn.shopify.com/s/files/1/0745/2662/1984/files/02_card_300yen_coupon_1540x1000px_c916bed4-ab8e-4ade-a670-3d04bfcfa4d0.jpg?v=1735208026" width="770px" height="500px" alt="SPECIAL COUPON ￥300OFF">
        </div>
      </div>
    `;
    span.insertAdjacentHTML("afterend", htmlContent);
    obs.disconnect(); // 監視を終了
  }
});

// 監視の設定
observer.observe(document.body, {
  childList: true,
  subtree: true,
});

// ヘッダーの購入ボタン表示
function getCartAndSearchClass() {
  if (window.innerWidth <= 768) {
    return ".header__wrapper .header__secondary-links .header__icon-wrapper, header__icon-list"; // モバイル用のクラス名
  } else {
    return ".header__wrapper .header__icon-list"; // デスクトップ用のクラス名
  }
}

document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM fully loaded and parsed");

  function handleScrollEvent() {
    console.log("Scroll event triggered");

    var scrollPosition = window.scrollY;
    var cartAndSearchClass = getCartAndSearchClass();
    var cartAndSearch = document.querySelectorAll(cartAndSearchClass);
    var customButton = document.getElementById("custom-button");

    // 要素が存在するか確認
    if (cartAndSearch.length > 0 && customButton) {
      console.log("Elements found:", {
        cartAndSearch: cartAndSearch.length,
        customButton: !!customButton,
      });

      // スクロール位置が100ピクセルを超えたら切り替える
      if (scrollPosition > 100) {
        cartAndSearch.forEach((element) => (element.style.display = "none"));
        customButton.style.display = "block";
      } else {
        cartAndSearch.forEach((element) => (element.style.display = "flex"));
        customButton.style.display = "none";
      }
    } else {
      console.log("Element not found:", {
        cartAndSearch: cartAndSearch.length,
        customButton: !!customButton,
      });
    }
  }

  // スクロールイベントリスナーを追加
  window.addEventListener("scroll", handleScrollEvent);

  // 画面サイズが変更されたときにクラス名を更新
  window.addEventListener("resize", handleScrollEvent);

  // 初回読み込み時にもクラス名を設定
  handleScrollEvent();

  // ページによって遷移先を変更
  window.navigateToCustomPage = function () {
    var currentPage = window.location.pathname;
    var targetUrl = "";

    // ページごとに遷移先を設定
    if (currentPage.includes("collection")) {
      targetUrl = "/products/2way-hipseat";
    } else if (currentPage.includes("product")) {
      targetUrl = "/products/2way-hipseat";
    } else {
      targetUrl = "/products/2way-hipseat";
    }

    window.location.href = targetUrl;
  };
});

// トップページ読み込みが完了したときにABOUTのビデオ再生
window.addEventListener("DOMContentLoaded", function () {
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top <
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
      rect.bottom > 0 &&
      rect.right > 0
    );
  }

  function playVideos() {
    const videoWrappers = document.getElementsByClassName(
      "video-wrapper--native"
    );
    for (let i = 0; i < videoWrappers.length; i++) {
      const videoWrapper = videoWrappers[i];
      // 表示されている要素のみをチェック
      if (window.getComputedStyle(videoWrapper).display !== "none") {
        const video = videoWrapper.querySelector("video");
        if (isInViewport(videoWrapper)) {
          if (video && video.paused) {
            video.play();
          }
        } else {
          if (video && !video.paused) {
            video.pause();
          }
        }
      }
    }
  }

  window.addEventListener("scroll", playVideos, false);
  window.addEventListener("resize", playVideos, false);

  // Initial check in case the video is already in view on page load
  playVideos();
});

/*  slick スライダー
  ---------------------------------------------------*/

function checkBreakPoint() {
  w = $(window).width();
  if (w <= 749) {
    // スマホ向け（749px以下のとき）
    $(".shopify-section--blog-posts .article-list")
      .not(".slick-initialized")
      .slick({
        infinite: false, // 無限スライド
        variableWidth: true,
        slidesPerView: 1,
        touchThreshold: 15,
        respondTo: "slider",
        prevArrow:
          '<div class="slide-arrow prev-arrow"><span class="arrow"></span></div>',
        nextArrow:
          '<div class="slide-arrow next-arrow"><span class="arrow"></span></div>',
      });
  } else {
    // PC向け
    $(".shopify-section--blog-posts .article-list.slick-initialized").slick(
      "unslick"
    );
  }
}
// ウインドウがリサイズする度にチェック
$(window).resize(function () {
  checkBreakPoint();
});
// 初回チェック
checkBreakPoint();

/*  スライダー 　商品
---------------------------------------------------*/
// $(window).on("load resize", function () {
//   var w = $(window).width();
//   if (w <= 749) {
//     const container = document.querySelector(".section-variation .inner");
//     const boxContainer = document.querySelector(".variation-list");
//     const leftArrow = document.querySelector(".Arrow.left");
//     const rightArrow = document.querySelector(".Arrow.right");

//     // scrollAmountを動的に計算する関数
//     function getScrollAmount() {
//       return container.offsetWidth * 0.6; // コンテナ幅の40%をスクロール量に設定、必要に応じて調整
//     }

//     leftArrow.addEventListener("click", () => {
//       const containerWidth = container.offsetWidth;
//       const maxScrollAmount = boxContainer.offsetWidth - containerWidth;
//       const currentScrollAmount =
//         Math.abs(parseInt(boxContainer.style.transform.split("(")[1])) || 0;
//       const newScrollAmount = Math.max(
//         currentScrollAmount - getScrollAmount(),
//         0
//       );
//       boxContainer.style.transform = `translateX(-${newScrollAmount}px)`;
//       updateArrowVisibility(newScrollAmount, maxScrollAmount);
//     });

//     rightArrow.addEventListener("click", () => {
//       const containerWidth = container.offsetWidth;
//       const maxScrollAmount = boxContainer.offsetWidth - containerWidth;
//       const currentScrollAmount =
//         Math.abs(parseInt(boxContainer.style.transform.split("(")[1])) || 0;
//       const newScrollAmount = Math.min(
//         currentScrollAmount + getScrollAmount(),
//         maxScrollAmount
//       );
//       boxContainer.style.transform = `translateX(-${newScrollAmount}px)`;
//       updateArrowVisibility(newScrollAmount, maxScrollAmount);
//     });
//   }
// });

document.querySelectorAll(".button.button--primary").forEach((element) => {
  if (element.classList.length === 2) {
    // 2つのクラスのみを持つ場合
    element.classList.add("exact-match");
  }
});

/*  スライダー 　商品
---------------------------------------------------*/
const swiperSlides = document.getElementsByClassName("swiper-slide");
const breakPoint = 500; // ブレークポイントを設定
let swiper;
let swiperBool;

window.addEventListener(
  "load",
  () => {
    if (breakPoint < window.innerWidth) {
      swiperBool = false;
    } else {
      createSwiper();
      swiperBool = true;
    }
  },
  false
);

window.addEventListener(
  "resize",
  () => {
    if (breakPoint < window.innerWidth && swiperBool) {
      swiper.destroy(false, true);
      swiperBool = false;
    } else if (breakPoint >= window.innerWidth && !swiperBool) {
      createSwiper();
      swiperBool = true;
    }
  },
  false
);
const createSwiper = () => {
  swiper = new Swiper(".swiper", {
    slidesPerView: "auto",
    spaceBetween: 56,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
};

/*  アコーディオン
---------------------------------------------------*/
document.addEventListener("DOMContentLoaded", function () {
  const hash = window.location.hash.substring(1);
  if (hash) {
    const detailsElement = document.getElementById(hash);
    if (detailsElement) {
      detailsElement.setAttribute("open", "");
    }
  }
});

$(function () {
  btn_topscroll();
  smooth_scroll();
  modal_window();
});

/*  トップスクロールボタン　表示切り替え
---------------------------------------------------*/
function btn_topscroll() {
  var top_scroll = $(".btn-topscroll");
  top_scroll.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 350) {
      top_scroll.stop(true, true).fadeIn();
    } else {
      top_scroll.stop(true, true).fadeOut();
    }
  });
  $("body").on("touchmove", function () {
    if ($(this).scrollTop() > 350) {
      top_scroll.stop(true, true).fadeIn();
    } else {
      top_scroll.stop(true, true).fadeOut();
    }
  });
}

/*  スムーススクロール
---------------------------------------------------*/
function smooth_scroll() {
  $(window).on("load resize", function () {
    var w = $(window).width();
    if (w >= 1024) {
      $('a[href^="#"]').click(function () {
        var speed = 500;
        var href = $(this).attr("href");
        var target = $(href == "#" || href == "" ? "html" : href);
        var position = target.offset().top - "80";
        if (href == "#") {
          position = target.offset().top;
        }
        $("html, body").stop().animate(
          {
            scrollTop: position,
          },
          speed,
          "swing"
        );
        return false;
      });
    } else {
      $('a[href^="#"]').click(function () {
        var speed = 500;
        var href = $(this).attr("href");
        var target = $(href == "#" || href == "" ? "html" : href);
        var position = target.offset().top - "80";
        if (href == "#") {
          position = target.offset().top;
        }
        $("html, body").stop().animate(
          {
            scrollTop: position,
          },
          speed,
          "swing"
        );
        return false;
      });
    }
  });
}

/*  レビューをもっと見る
---------------------------------------------------*/
// document.addEventListener("DOMContentLoaded", function () {
//   const button = document.getElementById("button-review-more");
//   const summary = document.querySelector(".review-summary");

//   button.addEventListener("click", function () {
//     summary.classList.add("expanded");
//     button.remove();
//   });
// });
document.addEventListener("DOMContentLoaded", function () {
  const button = document.getElementById("button-review-more");
  const summary = document.querySelector(".review-summary");

  if (button && summary) {
    button.addEventListener("click", function () {
      summary.classList.add("expanded");
      button.remove();
    });
  }
});

/*  バナー非表示
---------------------------------------------------*/
document.addEventListener("DOMContentLoaded", function () {
  const closeBtn = document.querySelector("#btn-close-banner");
  const banner = document.querySelector(".banner-container");

  if (closeBtn && banner) {
    closeBtn.addEventListener("click", function () {
      // フェードアウトクラスを追加
      banner.classList.add("is-hidden");

      // 完全に非表示にする場合（アニメ後）
      setTimeout(function () {
        banner.style.display = "none";
      }, 400); // transitionと同じ時間にする
    });
  }
});

document.querySelectorAll(".faq-tabs__menu-item").forEach((item) => {
  item.addEventListener("click", () => {
    const tabId = item.dataset.tab;

    // メニュー切り替え
    document
      .querySelectorAll(".faq-tabs__menu-item")
      .forEach((el) => el.classList.remove("active"));
    item.classList.add("active");

    // コンテンツ切り替え
    document.querySelectorAll(".faq-tab").forEach((tab) => {
      tab.classList.toggle("active", tab.id === tabId);
    });

    // ★ ここで accordion を再初期化（display:none → block で有効化）
    const openedTab = document.getElementById(tabId);
    openedTab.querySelectorAll(".collapsible-toggle").forEach((btn) => {
      btn.addEventListener("click", () => {
        const content = btn.nextElementSibling;
        content.classList.toggle("open");
      });
    });
  });
});

function modal_window() {
  let posi = 0;

  $(".modalwindow-trigger").on("click", function (e) {
    e.preventDefault();
    posi = $(window).scrollTop();
    var target = $(this).attr("href");
    if ($(target).is(":hidden")) {
      $("body").addClass("-modalOpen").css({
        overflow: "hidden",
      });
      $(target).fadeIn();
    }
  });

  $(".modalwindow-close , .btn-normal.-close").on("click", function (e) {
    $(".modal-window").fadeOut();
    $("body").removeClass("-modalOpen").css({
      overflow: "",
    });
    $(window).scrollTop(posi);
    $(".btn-mobile.-category").removeClass("-active");
  });
}

/* ----------------------------------
  lazyload Intersection Observer
---------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  let lazyImages = [].slice.call(document.querySelectorAll(".-lazyload"));
  if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          if (lazyImage.dataset.hasOwnProperty("src")) {
            lazyImage.src = lazyImage.dataset.src;
            lazyImage.dataset.src = "";
            delete lazyImage.dataset.src;
          }
          if (lazyImage.dataset.hasOwnProperty("srcset")) {
            lazyImage.srcset = lazyImage.dataset.srcset;
            lazyImage.dataset.srcset = "";
            delete lazyImage.dataset.srcset;
          }
          /*console.log("lazy loading!"); チェック用*/
          lazyImage.classList.remove("-lazyload");
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });
    lazyImages.forEach(function (lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  }
});
/* ----------------------------------
  hover
---------------------------------- */
var touch =
  "ontouchstart" in document.documentElement ||
  navigator.maxTouchPoints > 0 ||
  navigator.msMaxTouchPoints > 0;

if (touch) {
  try {
    for (var si in document.styleSheets) {
      var styleSheet = document.styleSheets[si];
      if (!styleSheet.rules) continue;

      for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
        if (!styleSheet.rules[ri].selectorText) continue;

        if (styleSheet.rules[ri].selectorText.match(":hover")) {
          styleSheet.deleteRule(ri);
        }
      }
    }
  } catch (ex) {}
}

$(function () {
  burger_menu();
  btn_topscroll();
  smooth_scroll();
  menu_slidedown();
  header_fixed();
  btnmore_styling();
  btnmore_usability();
  fadein();
  tab_faq();
  /*  スマホ バーガーメニュー&メニュー
  ---------------------------------------------------*/
  function burger_menu() {
    $("#burger-bars").click(function () {
      $(this).toggleClass("-open");
      $("#header-navigation").toggleClass("-open");
      $("#global-menu").toggleClass("-open");
    });
    $("#header-navigation").click(function () {
      $("#burger-bars").removeClass("-open");
      $("#header-navigation").removeClass("-open");
      $("#global-menu").removeClass("-open");
    });
  }
  /*  トップスクロールボタン　表示切り替え
  ---------------------------------------------------*/
  function btn_topscroll() {
    var top_scroll = $("#btn-topscroll");
    top_scroll.hide();
    $(window).scroll(function () {
      if ($(this).scrollTop() > 350) {
        top_scroll.stop(true, true).fadeIn();
      } else {
        top_scroll.stop(true, true).fadeOut();
      }
    });
    $("body").on("touchmove", function () {
      if ($(this).scrollTop() > 350) {
        top_scroll.stop(true, true).fadeIn();
      } else {
        top_scroll.stop(true, true).fadeOut();
      }
    });
  }
  /*  スムーススクロール
---------------------------------------------------*/
  function smooth_scroll() {
    $(window).on("load resize", function () {
      var w = $(window).width();
      if (w >= 1024) {
        $('a[href^="#"]').click(function () {
          var speed = 500;
          var href = $(this).attr("href");
          var target = $(href == "#" || href == "" ? "html" : href);
          var position = target.offset().top - "80";
          if (href == "#") {
            position = target.offset().top;
          }
          $("html, body").stop().animate(
            {
              scrollTop: position,
            },
            speed,
            "swing"
          );
          return false;
        });
      } else {
        $('a[href^="#"]').click(function () {
          var speed = 500;
          var href = $(this).attr("href");
          var target = $(href == "#" || href == "" ? "html" : href);
          var position = target.offset().top - "80";
          if (href == "#") {
            position = target.offset().top;
          }
          $("html, body").stop().animate(
            {
              scrollTop: position,
            },
            speed,
            "swing"
          );
          return false;
        });
      }
    });
  }
  /*  グローバルメニュー　スライドダウン
  ---------------------------------------------------*/
  function menu_slidedown() {
    $(window).on("load resize", function () {
      var w = $(window).width();
      if (w >= 1024) {
        $("#global-menu > .list").hover(
          function () {
            $(this).children(".menu-child").stop().slideDown("fast");
          },
          function () {
            $(this).children(".menu-child").stop().slideUp("fast");
          }
        );
      }
    });
  }
  /*  スクロール固定ヘッダー
  ---------------------------------------------------*/
  function header_fixed() {
    $(window).on("load resize", function () {
      var w = $(window).width();
      if (w >= 1024) {
        var header_menu = $("#header-site");
        var children_menu = $(".menu-child");
        $(window).scroll(function () {
          if ($(this).scrollTop() > 400) {
            header_menu.addClass("-fixed");
            //children_menu.addClass('-fixed');
          } else {
            header_menu.removeClass("-fixed");
            //children_menu.removeClass('-fixed');
          }
        });
      }
    });
  }
  /*  フェードイン
  ---------------------------------------------------*/
  function fadein() {
    $(function () {
      $(window).scroll(function () {
        var windowHeight = $(window).height(),
          scrollY = $(window).scrollTop();

        // 通常のfadein
        $(".scroll-fadein").each(function () {
          var thisPosition = $(this).offset().top;
          if (scrollY > thisPosition - windowHeight) {
            $(this).addClass("fadein-animation-start");
          }
        });

        // scroll-fadein-thumbnailの場合
        $(".scroll-fadein-thumbnail").each(function () {
          var thisPosition = $(this).offset().top;
          if (scrollY > thisPosition - windowHeight) {
            $(this).addClass("fadein-animation-start-thumbnail");
          }
        });
      });
    });
  }
  /*  FAQタブ切り替え
  ---------------------------------------------------*/
  function tab_faq() {
    const tabButtons = document.querySelectorAll(".tab-button");
    const tabContents = document.querySelectorAll(".tab-content");

    tabButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const targetTab = button.getAttribute("data-tab");

        tabButtons.forEach((btn) => {
          btn.classList.remove("-active");
        });
        tabContents.forEach((content) => {
          content.classList.remove("-active");
        });
        button.classList.add("-active");

        const targetContent = document.getElementById(targetTab);
        if (targetContent) {
          targetContent.classList.add("-active");
        }

        if (window.ScrollTrigger) {
          ScrollTrigger.refresh();
        }
      });
    });

    document.addEventListener("DOMContentLoaded", tab_faq);
  }
});

/*  もっと見るボタン[STYLING]
---------------------------------------------------*/
function btnmore_styling() {
  const init = 3; //初期表示数
  const more = 4; //追加表示数

  // 初期表示数以降のリスト内容を非表示に
  $(".styling-more-list li:nth-child(n+" + (init + 1) + ")").hide();

  //初期表示数以下であればMoreボタンを非表示
  $(".styling-more-list")
    .filter(function () {
      return $(this).find("li").length <= init;
    })
    .find(".btn-styling")
    .hide();

  // Moreボタンクリックで指定数表示
  $(".btn-styling").on("click", function () {
    let this_list = $(this).closest(".styling-more-list");
    this_list.find("li:hidden").slice(0, more).slideToggle();

    if (this_list.find("li:hidden").length == 0) {
      $(this).fadeOut();
    }
  });
}
/*  もっと見るボタン[USABILITY]
---------------------------------------------------*/
function btnmore_usability() {
  const init = 4; //初期表示数
  const more = 3; //追加表示数

  // 初期表示数以降のリスト内容を非表示に
  $(".usability-more-list li:nth-child(n+" + (init + 1) + ")").hide();

  //初期表示数以下であればMoreボタンを非表示
  $(".usability-more-list")
    .filter(function () {
      return $(this).find("li").length <= init;
    })
    .find(".btn-usability")
    .hide();

  // Moreボタンクリックで指定数表示
  $(".btn-usability").on("click", function () {
    let this_list = $(this).closest(".usability-more-list");
    this_list.find("li:hidden").slice(0, more).slideToggle();

    if (this_list.find("li:hidden").length == 0) {
      $(this).fadeOut();
    }
  });
}

//指定エリア内に要素を追従させる関数（追従要素,追従エリア）
const areaFixedFunk = (fixedElm, fixedArea) => {
  //エリアチェック
  const areas = document.querySelectorAll(fixedArea);
  if (areas.length === 0) {
    return;
  }

  //追従チェック関数
  const checkFixed = (target, area) => {
    //要素の位置と高さを取得
    const startPosi = area.getBoundingClientRect().top;
    const targetHeight = target.clientHeight;
    const areaHeight = area.clientHeight;
    const endPosi = startPosi + areaHeight;

    //エリア内の処理
    if (0 > startPosi && targetHeight < endPosi) {
      if (area.classList.contains("type-1")) {
        target.classList.add("fixed-styling");
        target.classList.remove("fixed-usability");
      } else if (area.classList.contains("type-2")) {
        target.classList.add("fixed-usability");
        target.classList.remove("fixed-styling");
      }
      target.style.top = "";

      //エリアより上の処理
    } else if (0 <= startPosi) {
      target.classList.remove("fixed-styling");
      target.classList.remove("fixed-usability");
      target.style.top = "";

      //エリアより下の処理
    } else {
      target.classList.remove("fixed-styling");
      target.classList.remove("fixed-usability");
      //停止位置を設定
      target.style.top = areaHeight - targetHeight + "px";
    }
  };

  //エリア毎に処理
  areas.forEach((area) => {
    //エリア内に追従要素が存在する場合のみ処理する
    const target = area.querySelector(fixedElm);
    if (target) {
      checkFixed(target, area);
      window.addEventListener("resize", () => {
        checkFixed(target, area);
      });
      window.addEventListener(
        "scroll",
        () => {
          checkFixed(target, area);
        },
        { passive: true }
      );
    }
  });
};

areaFixedFunk(".js-fixed-elm", ".js-fixed-area");
